import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output, Text } from '@components/Reference';
import { Spacer } from '@cleartrip/bento/lib';
import Sandbox from '@components/Sandbox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "float"
    }}>{`Float`}</h1>
    <p>{`Float and clearfix classes to help position elements.`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class reference`}</h2>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name">.c-left</Name>
        <Output mdxType="Output">float: left;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.f-right</Name>
        <Output mdxType="Output">float: right;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.f-none</Name>
        <Output mdxType="Output">float: none;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.clearfix</Name>
        <Text mdxType="Text">Clears the children floats</Text>
    </Property>
    </Reference>
    <h2 {...{
      "id": "float-left"
    }}>{`Float left`}</h2>
    <p><inlineCode parentName="p">{`.f-left`}</inlineCode>{` floats children within a container to its left.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block h-11 bg-secondary-100 w-100p clearfix ta-center">
      <span className="f-left">Hello</span>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="f-left">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "float-left-1"
    }}>{`Float left`}</h2>
    <p><inlineCode parentName="p">{`.f-right`}</inlineCode>{` floats children within a container to its left.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block h-11 bg-secondary-100 w-100p clearfix ta-center">
      <span className="f-right">Hello</span>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="f-right">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "float-none"
    }}>{`Float none`}</h2>
    <p><inlineCode parentName="p">{`.f-none`}</inlineCode>{` removes any float properties from the element.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block h-11 bg-secondary-100 w-100p clearfix ta-center">
      <span className="f-none">Hello</span>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="f-right">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "clearfix"
    }}>{`Clearfix`}</h2>
    <p><inlineCode parentName="p">{`.clearfix`}</inlineCode>{` forces an element to clear its children.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block bg-secondary-100 w-100p">
      <span className="f-left">left</span>
      <span className="f-right">right</span>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="clearfix">...</div>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      